import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useNavigate,useSearchParams } from 'react-router-dom';
import useTranslations from 'i18n/useTranslations';

const RegisterComplete = () => {
    const { t } = useTranslations();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const qPage = searchParams.get("page")
    const qRestaurantId = searchParams.get("restaurantId")
    console.log("q",qRestaurantId)
    const handleOnclick = () =>{
        if (qPage) {
            const redirectPage =`/${qPage}?restaurantId=${qRestaurantId}`
            navigate(redirectPage)
        } else {
            navigate('/profile')
        }
    }
    return (
        <div>
            <Helmet>
                <title>IMPACT Family</title>
                <meta name="title" content="Impact Family" />
                <meta name="description" content="Impact Family" />
                <meta name="keyword" content="" />
                <meta property="og:title" content="Impact Family" />
                <meta property="og:description" content="Impact Family" />
                <meta property="og:image" content="" />
                <meta property="og:url" content="" />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Impact Family" />
            </Helmet>
            <div id="pageRegister-complete">
                <main id="top">
                    <div className="wrapContent">
                        <section id="pComplete">

                            <div className="bComplete">
                                <div className="bLogo">
                                    <img src="assets/img/ci/complete/logo-welcome.svg" alt="" />
                                </div>
                                <div className="bText">
                                    <img src="assets/img/ci/complete/ico-complete.svg" alt="" />
                                    <h1>{t.registerComplete.header}</h1>
                                    <p>{t.registerComplete.body}</p>
                                    <p>{t.registerComplete.body1}</p>
                                </div>
                                <div className="bBtn">
                                    <a onClick={handleOnclick} className="btn white">{t.registerComplete.start}</a>
                                </div>
                            </div>

                        </section>
                    </div>
                </main>

            </div>
        </div>

    )
}

export default RegisterComplete